import ApiService from '../../services/ApiService';
import {
    GET_MASTER_DATA, LOADING_DATA, SHOW_SNACKBAR, GET_NOTIFICATIONS, CALL_LOAD_MORE_DATA, GET_VAULT_DATA,
    GET_CURRENT_ROUTE, SET_MULTI_SELECT_LIST, GET_MULTI_SELECT_DATA, GET_OCCUPATIONS, GET_VERTICAL_LIST, GET_PRODUCT_LIST,
    GET_CHANNEL_ZONE_LIST, GET_IMD_RELATION_LIST, UPDATE_VAULT_DATA, ADD_VAULT_DATA, GET_BIRTHDAY_LIST,SET_MAP_INFO
} from '../types/CommonType';
import { SUCCESS_STATUS, UNAUTHENTICATE_STATUS } from '../../constants/Config';

export const getCommonData = () => {
    return async (dispatch) => {
        const result = await ApiService.fetchData(`commondata`);
        if (result.status === SUCCESS_STATUS) {
            return dispatch({
                type: GET_MASTER_DATA,
                payload: result.data,
                error: false
            })
        } else {
            if (result.status === UNAUTHENTICATE_STATUS) {
                return dispatch({
                    type: GET_MASTER_DATA,
                    error: true,
                    isUnauthenticate: true,
                    msg: result.msg
                })
            }
            return dispatch({
                type: GET_MASTER_DATA,
                error: true,
                msg: result.msg
            })
        }
    }
}

export const callLoading = (status) => {
    return async (dispatch) => {
        return dispatch({
            type: LOADING_DATA,
            payload: status
        })
    }
}

export const callLoadingMore = (status) => {
    return async (dispatch) => {
        return dispatch({
            type: CALL_LOAD_MORE_DATA,
            payload: status
        })
    }
}

export const getSnackBar = (status, msg) => {
    return async (dispatch) => {
        return dispatch({
            type: SHOW_SNACKBAR,
            payload: { status, msg }
        })
    }
}

export const getNotifications = (data) => {

    return async (dispatch) => {
        const result = await ApiService.postData(`getNotificationList`, data);
        if (result.status === SUCCESS_STATUS) {
            return dispatch({
                type: GET_NOTIFICATIONS,
                payload: result.data,
                pageNo: data.pageNo,
                error: false
            })
        } else {
            if (result.status === UNAUTHENTICATE_STATUS) {
                return dispatch({
                    type: GET_NOTIFICATIONS,
                    error: true,
                    isUnauthenticate: true,
                    msg: result.msg
                })
            }
            return dispatch({
                type: GET_NOTIFICATIONS,
                error: true,
                msg: result.msg
            })
        }
    }
}

export const addVault = (data) => {
    return (dispatch) => {
        dispatch({
            type: ADD_VAULT_DATA,
            payload: data,
        })
    }
}

export const getVaults = (formData,url)=>{
    return async (dispatch)=>{
        const result = await ApiService.postData(`${url}`,formData);
        if(result.status === SUCCESS_STATUS){
            return dispatch({
                type: GET_VAULT_DATA,
                payload:result.data,
                pageNo:formData.pageNo,
                error: false
            })
        } else {
            if (result.status === UNAUTHENTICATE_STATUS) {
                return dispatch({
                    type: GET_VAULT_DATA,
                    error: true,
                    isUnauthenticate: true,
                    msg: result.msg
                })
            }
            return dispatch({
                type: GET_VAULT_DATA,
                error: true,
                msg: result.msg
            })
        }
    }
}

export const updateVault = (data) => {
    return async (dispatch) => {
        const result = await ApiService.postData(`updateActiveFilesStatus/${data.id}`);
        if (result.status === SUCCESS_STATUS) {
            return dispatch({
                type: UPDATE_VAULT_DATA,
                payload: data,
                error: false
            })
        } else {
            if (result.status === UNAUTHENTICATE_STATUS) {
                return dispatch({
                    type: UPDATE_VAULT_DATA,
                    error: true,
                    isUnauthenticate: true,
                    msg: result.msg
                })
            }
            return dispatch({
                type: UPDATE_VAULT_DATA,
                error: true,
                msg: result.msg
            })
        }
    }
}

export const submitFeedback = async (data) => {
    const result = await ApiService.postData(`submitFeedback`, data);
    if (result.status === SUCCESS_STATUS) {
        return {
            data: result.data,
            error: false
        }
    } else {
        if (result.status === UNAUTHENTICATE_STATUS) {
            return {
                error: true,
                msg: result.msg,
                isUnauthenticate: true,
            }
        }
        return {
            error: true,
            msg: result.msg
        }
    }
}

export const setCurrentRoute = (routeName) => {
    return (dispatch) => {
        return dispatch({
            type: GET_CURRENT_ROUTE,
            payload: routeName
        })
    }
}

export const setMultiSelectList = (data) => {
    return (dispatch) => {
        return dispatch({
            type: SET_MULTI_SELECT_LIST,
            payload: data
        })
    }
}

export const setMultiSelectData = (staus, data) => {
    return (dispatch) => {
        return dispatch({
            type: GET_MULTI_SELECT_DATA,
            payload: { staus: staus, data: data }
        })
    }
}



export const updateUserLatLng = async (data) => {
    const result = await ApiService.postData(`insertDistanceActivity`, data);
    if (result.status === SUCCESS_STATUS) {
        return {
            data: result.data,
            error: false
        }
    } else {
        if (result.status === UNAUTHENTICATE_STATUS) {
            return {
                error: true,
                msg: result.msg,
                isUnauthenticate: true,
            }
        }
        return {
            error: true,
            msg: result.msg
        }
    }

}

export const getGetData = async (url) => {
    const result = await ApiService.fetchData(url);
    if (result.status === SUCCESS_STATUS) {
        return {
            data: result.data,
            error: false
        }
    } else {
        if (result.status === UNAUTHENTICATE_STATUS) {
            return {
                error: true,
                isUnauthenticate: true,
                msg: result.msg
            }
        }
        return {
            error: true,
            msg: result.msg
        }
    }
}

export const getPostData = async (url, params) => {
    const result = await ApiService.postData(url, params);
    if (result.status === SUCCESS_STATUS) {
        return {
            data: result.data,
            error: false
        }
    } else {
        if (result.status === UNAUTHENTICATE_STATUS) {
            return {
                error: true,
                isUnauthenticate: true,
                msg: result.msg
            }
        }
        return {
            error: true,
            msg: result.msg
        }
    }
}

export const uploadFile = async (url, params) => {
    const result = await ApiService.postDataForFile(url, params);
    if (result.status === SUCCESS_STATUS) {
        return {
            data: result.data,
            error: false
        }
    } else {
        if (result.status === UNAUTHENTICATE_STATUS) {
            return {
                error: true,
                isUnauthenticate: true,
                msg: result.msg
            }
        }
        return {
            error: true,
            msg: result.msg
        }
    }
}

export const getOccupationData = () => {
    return async (dispatch) => {
        const result = await ApiService.postData(`getOccupationList`, {});

        if (result.status === SUCCESS_STATUS) {
            return dispatch({
                type: GET_OCCUPATIONS,
                payload: result.data,
                error: false
            })
        } else {
            if (result.status === UNAUTHENTICATE_STATUS) {
                return dispatch({
                    type: GET_OCCUPATIONS,
                    error: true,
                    isUnauthenticate: true,
                    msg: result.msg
                })
            }
            return dispatch({
                type: GET_OCCUPATIONS,
                error: true,
                msg: result.msg
            })
        }
    }
}

export const getVerticalList = () => {
    return async (dispatch) => {
        const result = await ApiService.postData(`getVerticalList`, {});
        if (result.status === SUCCESS_STATUS) {
            return dispatch({
                type: GET_VERTICAL_LIST,
                payload: result.data,
                error: false
            })
        } else {
            if (result.status === UNAUTHENTICATE_STATUS) {
                return dispatch({
                    type: GET_VERTICAL_LIST,
                    error: true,
                    isUnauthenticate: true,
                    msg: result.msg
                })
            }
            return dispatch({
                type: GET_VERTICAL_LIST,
                error: true,
                msg: result.msg
            })
        }
    }
}

export const getProductList = () => {
    return async (dispatch) => {
        const result = await ApiService.postData(`getProductList`, {});
        if (result.status === SUCCESS_STATUS) {
            return dispatch({
                type: GET_PRODUCT_LIST,
                payload: result.data,
                error: false
            })
        } else {
            if (result.status === UNAUTHENTICATE_STATUS) {
                return dispatch({
                    type: GET_PRODUCT_LIST,
                    error: true,
                    isUnauthenticate: true,
                    msg: result.msg
                })
            }
            return dispatch({
                type: GET_PRODUCT_LIST,
                error: true,
                msg: result.msg
            })
        }
    }
}

export const getImdRelationList = () => {
    return async (dispatch) => {
        const result = await ApiService.fetchData(`getImdRelationshipList`);
        if (result.status === SUCCESS_STATUS) {
            return dispatch({
                type: GET_IMD_RELATION_LIST,
                payload: result.data,
                error: false
            })
        } else {
            if (result.status === UNAUTHENTICATE_STATUS) {
                return dispatch({
                    type: GET_IMD_RELATION_LIST,
                    error: true,
                    isUnauthenticate: true,
                    msg: result.msg
                })
            }
            return dispatch({
                type: GET_IMD_RELATION_LIST,
                error: true,
                msg: result.msg
            })
        }
    }
}

export const getChanelZoneList = () => {
    return async (dispatch) => {
        const result = await ApiService.fetchData(`getChannelZoneList`);
        if (result.status === SUCCESS_STATUS) {
            return dispatch({
                type: GET_CHANNEL_ZONE_LIST,
                payload: result.data,
                error: false
            })
        } else {
            if (result.status === UNAUTHENTICATE_STATUS) {
                return dispatch({
                    type: GET_CHANNEL_ZONE_LIST,
                    error: true,
                    isUnauthenticate: true,
                    msg: result.msg
                })
            }
            return dispatch({
                type: GET_CHANNEL_ZONE_LIST,
                error: true,
                msg: result.msg
            })
        }
    }
}

export const getBirthdayList =(url,data)=>{
    return async (dispatch)=>{
        const result = await ApiService.postData(url,data);
        if(result.status === SUCCESS_STATUS){
            return dispatch({
                type: GET_BIRTHDAY_LIST,
                payload:result.data,
                pageNo:data.pageNo,
                error: false
            })
        }else{
            if(result.status === UNAUTHENTICATE_STATUS){
                return dispatch({
                    type: GET_BIRTHDAY_LIST,
                    error: true,
                    isUnauthenticate:true,
                    msg:result.msg
                })   
            }
            return dispatch({
                type: GET_BIRTHDAY_LIST,
                error: true,
                msg:result.msg
            })   
        }
    }
}

export const setMapInfo = (name) => {
    return (dispatch) => {
        return dispatch({
            type: SET_MAP_INFO,
            payload: name
        })
    }
}